import { getDigitsFromString } from '@/utils/getDigitsFromString'
import { Patient } from '../types/en-us'
import { DependenteAtivacaoPayload } from '../types/pt-br'

class SendDependentDataActivation {
  toPersistence(data: Patient): DependenteAtivacaoPayload {
    return {
      idPacienteDependente: data?.id,
      cpf: getDigitsFromString(data?.cpf),
      nome: data?.name,
      dataNascimento: data?.birthdate,
      email: data?.email,
      telefoneCelular: data?.cellphone,
    }
  }
}

export default new SendDependentDataActivation()
